import httpClient from './httpClient';

const END_POINT = 'api';


const getAllUsers = () => httpClient.get(END_POINT + "/callrequests");

// you can pass arguments to use as request parameters/data
const getUser = (user_id) => httpClient.get(END_POINT, { user_id });
// maybe more than one..
const createUser = (username, password) => httpClient.post(END_POINT, { username, password });

function validateToken() {
  return new Promise(function (resolve, reject){
    httpClient.get("/auth/validate_token")
      .then(response => resolve(response.data))
      .catch(error => reject(error.response));
  })
}

function getSocketAuth(){
  return new Promise(function (resolve, reject){
    httpClient.get("/api/sockettokens")
      .then(response => resolve(response.data))
      .catch(error => reject(error.response));
  })
}

function getOnlineUsers(){
  return new Promise(function (resolve, reject){
    httpClient.get("/api/callrequests")
      .then(response => resolve(response.data))
      .catch(error => reject(error.response));
  })
}

function createContactAndCall(inputdata){
  return new Promise(function (resolve, reject){

    httpClient.post("/api/callrequests/createcontactandcall", inputdata)
      .then(response => resolve(response.data))
      .catch(error => reject(error.response));
  })
}

function createAnswer(id){
  return new Promise(function (resolve, reject){
    httpClient.post("/api/operators/answer/" + id, {})
      .then(response => resolve(response.data))
      .catch(error => reject(error.response));
  })
}

function resetCall(id,callerid){
  return new Promise(function (resolve, reject){
    httpClient.delete("/api/callrequests/" + id + "?caller_id=" + callerid)
      .then(response => resolve(response.data))
      .catch(error => reject(error.response));
  })
}

function getAllcalls(){
  return new Promise(function (resolve, reject){
    httpClient.delete("/api/operators")
      .then(response => resolve(response.data))
      .catch(error => reject(error.response));
  })
}
export {
    getAllUsers,
    getUser,
    createUser,
    validateToken,
    getSocketAuth,
    getOnlineUsers,
    createContactAndCall,
    createAnswer,
    resetCall,
    getAllcalls
}